export interface Story {
    StoryId: number,
    Title: string,
    Description: string,
    Uri: string,
    Source: string,
    Media: string,
    ScrapedDate: string,
    Hash: string,
    SummaryText: string | null,
    CanSummarize: boolean
}

export interface Pagination {
    Page: number,
    Limit: number,
    Total: number,
    Pages: number
}

export interface StoryPagination extends Pagination {
    Source: number
}

export interface StoryList {
    Stories: [Story],
    Pagination: StoryPagination
}

export enum SourceType {
    ENDI = 1,
    Vocero,
    Noticel,
    Legislacion
}

export enum LegislationSourceType {
    Legislation = 1,
    RecentLegislation,
    SubscribedLegislation,
    SearchedLegislation,
    SearchedSubscribedLegislation
}

export interface ApiResult<T> {
    Data: T,
    Error: any|null
}

export interface Legislation {
    LegislationId: number,
    Number: string,
    FiledDate: string,
    Title: string,
    Author: string,
    CoAuthor: string,
    Uri: string,
    Committe: number,
    AdministrationId: number,
    LastEvent: string,
    ScrapedDate: string,
    Hash: string,
    Docs: LegislationDoc[],
    Events: LegislationEvent[],
    IsSubscribed: boolean
}

export interface RecentLegislation {
    LegislationId: number,
    Number: number,
    FiledDate: string,
    Title: string,
    Author: string,
    CoAuthor: string,
    Uri: string,
    AdministrationId: number,
    LastEvent: string,
    ScrapedDate: string,
    Hash: string,
    DocDesc: string,
    DocUri: string,
    DocType: string,
    DocSummary: string,
    HasDocument: boolean,
    EventDescription: string
}

export interface SubscribedLegislation extends Legislation {
    Tags: string[]|undefined
}

export interface LegislationList {
    Legislation: [Legislation]
    Pagination: Pagination,
    Filter: LegislationFilter
}

export interface RecentLegislationList {
    Legislation: [RecentLegislation]
    Pagination: Pagination,
    Filter: LegislationFilter
}

export interface SubscribedLegislationList {
    Legislation: [SubscribedLegislation]
    Pagination: Pagination,
    Filter: LegislationFilter
}

export interface ArticleSummary {
    Body: string
}

export interface LegislationSummary {
    Body: string
}

export interface UpdateStorySummary {
    Id: number,
    Summary: string
}

export interface UpdateLegDocSummary {
    Id: number,
    docIndex: number,
    Summary: string
}

export interface UpdateRecentLegDocSummary {
    Id: number,
    Summary: string
}

export interface UpdateCommitteeConfig {
    Config: CommitteeConfig
}

export interface UpdateSubscribedLegislationTags {
    LegislationId: number,
    Tags: string[]
}

export interface UpdateIsSubscribedToProject {
    LegislationId: number,
    IsSubscribed: boolean
}

export interface UpdateLegislationEvents {
    LegislationIndex: number,
    Events: LegislationEvent[]
}

export interface RemoveCommitteeConfig {
    AdministrationId: number,
    CommitteeId: number
}

export interface LegislationDoc {
    LegDocId: number,
    Description: string,
    DocType: string,
    Uri: string,
    DocSummary: string,
    LegislationIdFk: number
}

export interface LegislationEvent {
    LegEventId: number,
    Title: string,
    Description: string,
    Uri: string,
    DocType: string,
    DocSummary: string,
    LegislationIdFk: number,
    HasDocument: boolean
}

export interface CommitteeConfig {
    AdministrationId: number,
    CommitteeId: number,
    NotifyOnNewLegislation: boolean,
    NotificationFilters: string[]
}

export interface NewsConfig {
    SourceType: SourceType,
    NotifyOnNewNews: boolean,
    DefaultFilter: string,
    NotificationFilters: string[]
}

export interface ConfigurationOptions {
    Committees: CommitteeConfig[],
    News: NewsConfig[]
}

export interface Configuration {
    ConfigId: number,
    Config: ConfigurationOptions
}

export interface LegislationFilter {
    searchText: string,
    committee?: number,
    committees?: number[],
    category?: string
}

export interface LegislationConfig {
    WatchedLegislation: number[]
}

export interface LoginResponse {
    CodeId: string,
    IsConfirmed: boolean
}

export interface VerifyLoginCodeResponse {
    SessionToken: string,
    Channel: string
}

export interface RefreshResponse extends VerifyLoginCodeResponse {
    IsConfirmed: boolean
}

export interface Notification {
    NotifId: number,
    MatchedLegislation: string[],
    MatchedNews: string[],
    Message: string,
    Payload: string,
    NotificationDate: string,
    Read: boolean,
    UserIdFk: number,
    MatchedProjectsForEvents: number[]
}